import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';
import { GetOrderIntentEstimateRequestForPartnerOrderReview } from '@atlassian/cssxp-typescommon';

const client = createAxiosClient({ baseURL: '/api/1/order-estimate' }, ServiceProxyMap.PPC_BFF);

export const generateOrderEstimatePDF = async (requestPayload: GetOrderIntentEstimateRequestForPartnerOrderReview) => {
  const response = await client.post('/pdf', requestPayload, {
    responseType: 'blob',
    validateStatus: (status) => status === 200,
    headers: {
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};
